import { combineReducers } from 'redux';
import { storeKey as tokenKey, reducer as tokenReducer } from './tokenDuck';

export { jwtListener } from './jwtListener';
export { jwtMiddleware } from './jwtMiddleware';
export { default as tokenDuck } from './tokenDuck';
export { useTokenRefresh } from './useTokenRefresh';
export const jwtReducer = combineReducers({
  [tokenKey]: tokenReducer,
});
